/**
 * This component is currently unused but kept for future implementation.
 * Remove if no longer needed.
 */

"use client";
import { Box, Heading } from "@chakra-ui/react";
import { PageBlockFeaturedCarousel } from "lib/gcms";
import { SectionTemplate } from "../section-template";
import { Gallery } from "./carousel";

export const FeaturedCarousel = ({
  header,
  bg,
  color,
}: PageBlockFeaturedCarousel) => {
  const textHorLineStyle = {
    bg: "black",
    color: "black",
    h: "1px",
    w: "60px",
    content: `""`,
    flex: "1",
    display: "inline-block",
    verticalAlign: "middle",
  };
  return (
    <SectionTemplate {...{ bg, color }}>
      <Box mx="auto" px={{ base: "0", md: "8", lg: "16" }} position="relative">
        <Heading
          as="h2"
          fontWeight="bold"
          size="md"
          mx="auto"
          w="fit-content"
          _before={{ ...textHorLineStyle, mr: "15px" }}
          _after={{ ...textHorLineStyle, ml: "15px" }}
        >
          {header}
        </Heading>
        <Gallery />
      </Box>
    </SectionTemplate>
  );
};
